import { Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { ExpensePaymentStatusAPIModel } from 'src/models/api.model'
import {GlobalConstants, REJECTION_TYPE} from "../../../constants/global-constants";
import {AppState} from "../../../store/state/app.state";
import {UPDATE_REJECTION_TYPE} from "../../../store/action/payment.action";
import {Store} from "@ngrx/store";

@Component({
  selector: 'app-payment-history-dialog',
  templateUrl: './payment-history-dialog.component.html',
  styleUrls: ['./payment-history-dialog.component.scss']
})
export class PaymentHistoryDialogComponent implements OnInit {
  paymentHistoryList: ExpensePaymentStatusAPIModel[]
  rejectionType: REJECTION_TYPE | null

  constructor(
    public dialogRef: MatDialogRef<PaymentHistoryDialogComponent>,
    private appState: Store<AppState>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.paymentHistoryList = data
  }

  ngOnInit() {}

  onCloseClick(): void {
    this.dialogRef.close()
  }

  getKeyValuePairs(obj: any): Array<{ key: string; value: any }> {
    if (!obj) {
      return []
    }
    return Object.keys(obj).map(key => ({ key, value: obj[key] }))
  }

  getRejectionLabel(rejectionValue: string): string {
    const rejectionType = GlobalConstants.REJECTION_TYPE_OPTION_LIST.find(
      option => option.value === rejectionValue
    );
    return rejectionType ? rejectionType.label : '';
  }

  protected readonly GlobalConstants = GlobalConstants;

  updateRejectionType(id: string) {
    this.appState.dispatch(UPDATE_REJECTION_TYPE({id, rejectionType: this.rejectionType}))
  }
}
